/* istanbul ignore file */ /* this file is not used or will be deleted in other branches */
import React, { memo, useMemo } from 'react';
import ReactDatePicker from 'react-datepicker';
import { FieldWrapper } from './FieldWrapper';
import { MaskedDateInput } from './MaskedInput';

export interface DateRangeTypes {
  [x: string]: undefined | Date;
}

interface DateRangeProps {
  date: DateRangeTypes;
  label: string;
  onChange: (obj: DateRangeTypes) => void;
  name?: string;
  sublabel?: string;
  placeholderFrom?: string;
  placeholderTo?: string;
  disabled?: boolean;
  error?: string;
  startDate?: Date;
  endDate?: Date;
  minDate?: Date;
  maxDate?: Date;
}

const DateRange: React.FC<DateRangeProps> = ({
  date,
  name,
  label,
  sublabel,
  placeholderFrom = 'MM/DD/YYYY',
  placeholderTo = 'MM/DD/YYYY',
  error,
  onChange,
  minDate,
  maxDate,
  startDate,
  endDate,
  ...props
}) => {
  const onSetDate = (key: string, value: Date) => {
    const newDate = { ...date, [key]: value };
    onChange(newDate);
  };

  const isFromError = useMemo(() => {
    if (date) {
      if (Object.values(date).some((el) => Boolean(el))) {
        return !date.from;
      }
      return false;
    }
  }, [date]);

  const isToError = useMemo(() => {
    if (date) {
      if (Object.values(date).some((el) => Boolean(el))) {
        return !date.to;
      }
      return false;
    }
  }, [date]);

  return (
    <FieldWrapper name={name} label={label} isError={isFromError || isToError} error={error}>
      {sublabel && <p className='mb-1 text-xs tracking-wide font-effra text-black-default'>{sublabel}</p>}
      <div className='flex gap-2'>
        <div className='w-full'>
          <ReactDatePicker
            name={`${name}-from`}
            placeholderText={placeholderFrom}
            selected={date?.from}
            onChange={(date: Date) => onSetDate('from', date)}
            autoComplete='off'
            selectsStart
            startDate={startDate}
            endDate={endDate}
            maxDate={maxDate}
            customInput={<MaskedDateInput isError={isFromError} />}
            {...props}
          />
        </div>
        <div className='w-full'>
          <ReactDatePicker
            name={`${name}-to`}
            placeholderText={placeholderTo}
            selected={date?.to}
            onChange={(date: Date) => onSetDate('to', date)}
            autoComplete='off'
            className='form-field react-datepicker_custom'
            selectsEnd
            startDate={startDate}
            endDate={endDate}
            minDate={minDate}
            customInput={<MaskedDateInput isError={isToError} />}
            {...props}
          />
        </div>
      </div>
    </FieldWrapper>
  );
};

const MemoizedDateRange = memo(DateRange);
export { MemoizedDateRange as DateRange };
